import { Pipe, PipeTransform } from '@angular/core';

import { recursoCampanhaSituacoes } from '../recurso-campanha-situacao';

@Pipe({
    name: 'recursoCampanhaSituacao'
})
export class RecursoCampanhaSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = recursoCampanhaSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return recursoCampanhaSituacoes[index].nome;
        }
        return '';
    }
}
